import React from 'react';

const IconLogo = () => (
  <span className="material-symbols-outlined" aria-hidden="true">
    home
  </span>
);

export default IconLogo;
